module.exports = __webpack_public_path__ + "img/1F620.f99585b2.svg";